<template>
  <q-menu
    v-bind="$attrs"
    @show="$emit('show')"
    @hide="$emit('hide')"
  >
    <q-list
      class="dropdown-list"
    >
      <q-item
        v-if="canMarkAsUnread"
        clickable
        v-close-popup
        data-testid="atendimento-marcar-nao-lida"
        @click="$emit('mark-as-unread')"
        class="row items-center justify-center"
      >
        <q-icon
          name="mdi-message-alert-outline"
          class="q-mr-sm"
        />
        <q-item-section class="dropdown-text q-mb-xs">
          Marcar como não lida
        </q-item-section>
      </q-item>
      <!-- <q-item
        v-if="hasManualUnread"
        clickable
        v-close-popup
        @click="$emit('mark-as-read')"
      >
        <q-item-section>Marcar como lida</q-item-section>
      </q-item> -->
    </q-list>
  </q-menu>
</template>

<script>

export default {
  name: 'AttendanceReadUnreadMenu',
  inheritAttrs: false,

  props: {
    canMarkAsUnread: {
      type: Boolean,
      default: false
    },

    hasManualUnread: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass">

.dropdown-text
  font-weight: bold
  font-size: 12px
.dropdown-list
  .q-item
    padding-right: 10px
    padding-left: 10px
    padding-top: 10px
    min-height: 30px
</style>
